module.exports = __webpack_public_path__ + "static/preislerova-a75a1232b1a261ba6234cded055630ad.jpg";